export default __webpack_public_path__ + "static/media/Logo.64930792.svg";